import {
  Control,
  Controller,
  FieldError,
  FieldValues,
  Path,
} from 'react-hook-form'
import { FormHelperText, TextField } from '@mui/material'

interface InputTextProps<K extends FieldValues, T> {
  name: Path<K>
  control: Control<K>
  error?: FieldError
  value?: string
  desabilitado?: boolean
  readonly?: boolean
  label?: string
  color?: string
  isInputBold?: boolean;
  inputProps?: any
  onKeyDown?: (e: any) => void
}

InputText.defaultProps = {}

export default function InputText<K extends FieldValues, T>(
  props: InputTextProps<K, T>,
) {
  // const { field: inputField } = useController({
  //   name: props.name,
  //   control: props.control,
  // })

  // useEffect(() => {
  //   if (props.value === null || props.value === undefined) {
  //     inputField.onChange('')
  //   } else {
  //     inputField.onChange(props.value)
  //   }
  // }, [props.value])

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        render={({ field }) => (

          <>
            <TextField
              {...field}
              value={field.value ?? ""}
              type="text"
              onChange={(val) => field.onChange(val.target.value)}
              disabled={props.desabilitado}
              autoComplete="off"
              onKeyDown={props.onKeyDown}
              slotProps={{
                htmlInput: {
                  readOnly: props.readonly
                },
              }}
              inputProps={props.inputProps}
              // autoFocus
              margin="dense"
              label={props.label}
              fullWidth
              variant="standard"
              error={!!props.error}
              //style={{color: props.color}}
              sx={{
                "& .MuiInputBase-input": {
                  color: props.color,
                  fontWeight: props.isInputBold ? 'bold' : ''
                },
              }}
            />
            {props.error && <FormHelperText error>{props.error.message}</FormHelperText>}
          </>
        )}
      />


    </>
  )
}
